<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Envia y trae datos entre AVE y otros servicios.
                Muestra el estado de las últimas sincronizaciones
                y si hubo errores. Úsalo para verificar que la 
                información quedó actualizada.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Configuración de sincronización
          </h2> 
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Configura los <b>servicios integrados</b> en AVE.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Servicios de sincronización</div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- Show filters button -->
          <!--<button mat-icon-button color="primary" (click)="sidenav.toggle()" matTooltip="Mostrar filtros">
            <mat-icon svgIcon="filter_list"></mat-icon>
          </button>-->
          <!-- <button mat-icon-button color="primary" (click)="openConfigurationModal()" matTooltip="Configurar Canal de Conexion">
            <mat-icon svgIcon="heroicons_outline:cog-8-tooth"></mat-icon>
          </button> -->
          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Glosario">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>
          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item>
              <mat-icon style="color: #008000;">lan</mat-icon>
              <span>En Progreso</span>
            </button>
            <button mat-menu-item>
              <mat-icon class="material-icons-outlined">lan</mat-icon>
              <span>Libre</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" 
              (matSortChange)="changeSort($event)" matSort>
              <ng-container matColumnDef="nro">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left"></th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left uppercase">
                  @if(element?.inProgress){
                    <mat-icon style="color: #008000;">lan</mat-icon>
                  }
                  @if(!element?.inProgress){
                    <mat-icon class="material-icons-outlined">lan</mat-icon>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Interfaz</th>
                <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                  <b class="f-10">{{ element.code }}</b><br> <span class="uppercase">{{element.name}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
                <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                  <b>{{ element?.type }}</b><br>{{element?.connectionType}}
                </td>
              </ng-container>
              <ng-container matColumnDef="module">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Módulo</th>
                <td mat-cell *matCellDef="let element">{{element.module}}</td>
              </ng-container>
              <ng-container matColumnDef="apiUrl">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>URL</th>
                <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                  <b>{{ element?.apiUrl }}</b> <br> {{element?.apiMethod}}
                </td>
              </ng-container>
              <ng-container matColumnDef="frecuency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Frecuencia</th>
                <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                  <b class="uppercase">{{ getFrecuencyName(element.frequency) }}</b> <br>{{element?.hours}} {{element.eachTime ? '|' + element.eachTime : ''}}
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Acción</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <!-- FUTURO <button mat-menu-item (click)="openEditModal(element)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button> -->
                    <button mat-menu-item (click)="openSyncDialog(element)" [disabled]="element?.inProgress">
                      <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
                      <span>Sincronización Manual</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
          </div>
        </div>
        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>
  </div>    

  <!-- Filtros -->
  <app-filter
    (onFilterEvent)="findAllWithCount()"
    (onCleanEvent)="clearFilters()"
  >
    <app-configuration-filters
          [form]="form"
          [company]="true"
        ></app-configuration-filters>
  </app-filter>
</mat-sidenav-container>

<ng-template #syncDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon
        svgIcon="heroicons_outline:exclamation-triangle"
        class="text-red-500 ml-4 mt-6"
        style="font-size: 32px"
      ></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Sincronizar registro
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>Este proceso se va a ejecutar en segundo plano</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">
      Conservar
    </button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Sincronizar
    </button>
  </mat-dialog-actions>
</ng-template>